import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OurBrandsComponent } from '../brand/our-brands/our-brands.component';
import { BioguardComponent } from './bioguard/bioguard.component';
import { SpaguardComponent } from './spaguard/spaguard.component';
import { BrandRoutingModule } from './brand-routing.module';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { BaquacilComponent } from './baquacil/baquacil.component';
import { FreshwaterComponent } from './freshwater/freshwater.component';
import { FrogComponent } from './frog/frog.component';
import { HotTubSerumComponent } from './hot-tub-serum/hot-tub-serum.component';
import { LeisureTimeComponent } from './leisure-time/leisure-time.component';
import { PoolifeComponent } from './poolife/poolife.component';
import { SironaComponent } from './sirona/sirona.component';

@NgModule({
    imports: [
    CommonModule,
    BrandRoutingModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    OurBrandsComponent,
    BioguardComponent,
    SpaguardComponent,
    BaquacilComponent,
    FreshwaterComponent,
    FrogComponent,
    HotTubSerumComponent,
    LeisureTimeComponent,
    PoolifeComponent,
    SironaComponent
]
})
export class BrandModule { }
